"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPlay = void 0;
var util_1 = require("./util");
var videoPlay = function (event) {
    return (0, util_1.videoEvent)(event, "video-play");
};
exports.videoPlay = videoPlay;
